/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Intisloweraspect9Inputs */



/**

* @param {_Filter_Class_Intisloweraspect9Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_intisloweraspect9 = /** @type {((inputs?: _Filter_Class_Intisloweraspect9Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Intisloweraspect9Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ist kleiner-gleich")
});
export { _filter_class_intisloweraspect9 as "_filter_class_IntISLOWERAspect" }